import { render } from "./MenuEditingCore.vue?vue&type=template&id=08b0cc7c"
import script from "./MenuEditingCore.vue?vue&type=script&lang=js"
export * from "./MenuEditingCore.vue?vue&type=script&lang=js"
script.render = render

export default script